import React, { useEffect, useRef, useState } from 'react';
import './sidebar.css';
import { FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useIsAdmin } from '../../hooks/useIsAdmin';

function Sidebar({ setSideBar }) {
  const sidebarRef = useRef(null);
  const { isAdmin } = useIsAdmin();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSideBar(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [setSideBar]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') setSideBar(false);
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [setSideBar]);

  return (
    <div className="side-bar-container" role="dialog" aria-modal="true">
      <div className="side-bar" ref={sidebarRef}>
        <div className="sidebar-logo">
          <h2>Alchemy Mix</h2>
          <div
            className="close-sidebar"
            onClick={() => setSideBar(false)}
            role="button"
            tabIndex={0}
            aria-label="Close sidebar"
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setSideBar(false);
              }
            }}
          >
            <FaTimes />
          </div>
        </div>

        <nav className="sidebar-menu">
          <h5>Navigation</h5>
          <Link to="/" onClick={() => setSideBar(false)}>
            <p>Home</p>
          </Link>
          <Link to="/news" onClick={() => setSideBar(false)}>
            <p>News</p>
          </Link>
        </nav>

        <div className="sidebar-items-plugin">
          <h5>Channel</h5>
          <Link to="/channels" onClick={() => setSideBar(false)}>
            <p>Channels</p>
          </Link>
        </div>

        <div className="sidebar-items-plugin">
          <h5>Documentaries</h5>
          <Link to="/documentaries" onClick={() => setSideBar(false)}>
            <p>Documentaries</p>
          </Link>
          <Link to="/documentaries/new" onClick={() => setSideBar(false)}>
            <p>New documentary</p>
          </Link>
          <Link to="/documentaries/brand-kits" onClick={() => setSideBar(false)}>
            <p>Brand kits</p>
          </Link>
        </div>

        <div className="sidebar-items-plugin">
          <h5>Plugins</h5>
          <Link to="/voices" onClick={() => setSideBar(false)}>
            <p>Voices</p>
          </Link>
          <Link to="/background" onClick={() => setSideBar(false)}>
            <p>Background Music</p>
          </Link>
          <Link to="/drafts" onClick={() => setSideBar(false)}>
            <p>Drafts</p>
          </Link>

          <div className="sub-draft">
            <Link to="/processing-drafts" onClick={() => setSideBar(false)}>
              <p>Processing Drafts</p>
            </Link>
            <Link to="/completed-drafts" onClick={() => setSideBar(false)}>
              <p>Completed Drafts</p>
            </Link>
          </div>

          <Link to="/completed" onClick={() => setSideBar(false)}>
            <p>Completed Videos</p>
          </Link>
        </div>

        {mounted && isAdmin && (
          <div className="sidebar-items-plugin">
            <h5>Admin</h5>
            <Link to="/admin/pipeline" onClick={() => setSideBar(false)}>
              <p>Pipeline manager</p>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default Sidebar;
